import { render, staticRenderFns } from "./ProjectWrapper.vue?vue&type=template&id=f4eb3bf8&"
import script from "./ProjectWrapper.vue?vue&type=script&lang=js&"
export * from "./ProjectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports